import { api } from "../Configurations/axios";


const GetPleaSocioEnvironmentalbyPleaId = async (pleaId: string) => {
  try {
    const result = await api.get(`/PleaSocioEnvironmental/GetByPleaId?pleaId=${pleaId}`);
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
}

const PleaSocioEnvironmentalPost = async (contaminatedOrDegradedArea: string, reportingOrCertification: string, insurancePolicies: string, projectSpace: string,projectActivities: string ,requiresLicensing: string,hasAllAuthorizations: string, userEmail: string, pleaId: string ) => {
    try {
      const result = await api.post('/PleaSocioEnvironmental/Post', {
        ContaminatedOrDegradedArea : contaminatedOrDegradedArea,
        ReportingOrCertification : reportingOrCertification,
        InsurancePolicies : insurancePolicies,
        ProjectSpace : projectSpace,
        ProjectActivities : projectActivities,
        RequiresLicensing : requiresLicensing,
        HasAllAuthorizations : hasAllAuthorizations,
        UserEmail : userEmail,
        PleaId : pleaId,
      });
      const response = await result.data;
      return response;
    } catch (error: any) {
      throw new Error(error.response.data);
    }
  
  
  }

  export{
    GetPleaSocioEnvironmentalbyPleaId,
    PleaSocioEnvironmentalPost
  }